/* address */
export const GET_COUNTRIES = "GET_COUNTRIES"
export const GET_COUNTRIES_SUCCESS = "GET_COUNTRIES_SUCCESS"
export const GET_COUNTRIES_FAIL = "GET_COUNTRIES_FAIL"

export const GET_CITIES_BY_COUNTRY = "GET_CITIES_BY_COUNTRY"
export const GET_CITIES_BY_COUNTRY_SUCCESS = "GET_CITIES_BY_COUNTRY_SUCCESS"
export const GET_CITIES_BY_COUNTRY_FAIL = "GET_CITIES_BY_COUNTRY_FAIL"



